import { render, staticRenderFns } from "./corporate-branch.vue?vue&type=template&id=7f66f4ae&scoped=true&"
import script from "./corporate-branch.vue?vue&type=script&lang=js&"
export * from "./corporate-branch.vue?vue&type=script&lang=js&"
import style0 from "./corporate-branch.vue?vue&type=style&index=0&id=7f66f4ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f66f4ae",
  null
  
)

export default component.exports